import africanCountries from "./africanCountries";

const isUserAfrican = userCountry =>
  !!africanCountries.find(({ country_code }) => country_code === userCountry);

export default isUserAfrican;
